/**
 * Get fetch
 */
export const getFetch = (): any => {
  let fetch;
  // @typescript-eslint/no-implied-eval
  // eslint-disable-next-line @typescript-eslint/no-implied-eval,no-new-func
  const global = Function('return this;')();
  if (typeof window !== 'undefined') {
    fetch = (window as any).fetch;
    if (typeof fetch === 'undefined') {
      // for jest
      fetch = require('node-fetch');
      global.fetch = fetch;
    }
  } else {
    fetch = require('node-fetch');
    global.fetch = fetch;
  }
  return fetch;
};
